import { Step } from 'signup-constants/Step';
import { Data } from 'signup-constants/signupData/Data';
import { ErrorKey } from '../app-active-error/ErrorKey';
import { LoadingKey } from '../app-active-loading/LoadingKey';
import { VerificationType } from '../app/VerificationType';
import { NextStepManager } from '../flow-management/NextStepManager';
import { setNextStep } from '../flow-management/setNextStep';
import { EndpointKey } from '../http/EndpointKey';
import Logger from '../lib/Logger';
import { handleRecaptchaFailed, handleRecaptchaMissingInformation } from '../recaptcha/utils/recaptchaHandlers';
import { getHasRecaptchaFailed, getIsMissingRecaptchaInformation } from '../recaptcha/utils/recaptchaMessageParsing';
import { setVerificationType, updateVerificationExpired } from '../store/app/action-creators';
import { setError } from '../store/error/action-creators';
import { clearLoadingStatus } from '../store/loading-status/action-creators';
import parseErrorData from '../store/signup-data-validation/utils/parseErrorData';
import { bulkEmptySignupDataAndSetFresh } from '../store/signup-data/action-creators';
import { codeVerificationExpiredRefreshInitiate } from '../store/step-code-verification/action-creators';
import { Tracker } from '../store/tracking/action-creators';
import { getVerificationType } from '../store/app/selectors';
const LOG = Logger.getLogger('handleSignupError');
export const handleSignupError = (error, dispatch, getState) => {
  const statusCode = error.status;
  let message = 'unknown-message';
  let errorType = '';
  if (error.data) {
    const parsed = parseErrorData(error.data);
    message = parsed.message;
    errorType = parsed.errorType;
  }
  LOG.error('Signup Request Error', {
    extra: {
      message,
      statusCode
    }
  });
  if (statusCode === 429) {
    dispatch(Tracker.signupInteraction('creation-error-rate-limited'));
    return dispatch(setError(ErrorKey.RateLimitedCreationError, {
      message
    }));
  }
  if (error.data) {
    if (statusCode === 404 && errorType === 'EMAIL_VERIFICATION_NOT_FOUND') {
      if (message) {
        dispatch(Tracker.creationError('creation-error-standard', `${statusCode} - ${message}`));
      }
      dispatch(Tracker.signupInteraction('signup-error-verification-expired'));
      dispatch(updateVerificationExpired(true));
      dispatch(setVerificationType(VerificationType.EmailByCode));
      dispatch(bulkEmptySignupDataAndSetFresh([Data.CodeVerification]));
      dispatch(codeVerificationExpiredRefreshInitiate());
      dispatch(setNextStep({
        rebuilder: NextStepManager.pushNextSteps(Step.CodeVerification)
      }));
      return dispatch(clearLoadingStatus(LoadingKey.SignupRequest));
    }
    if (message && message.indexOf('verify_user_first') >= 0) {
      dispatch(Tracker.signupInteraction('creation-error-verify-first'));
      return dispatch(setError(ErrorKey.VerifyFirstCreationError, {
        message
      }));
    } else if (getHasRecaptchaFailed(message)) {
      const metricsCounterDimensions = {
        verificationType: getVerificationType(getState()) || ''
      };
      return handleRecaptchaFailed({
        state: getState(),
        message,
        statusCode,
        LocalLogger: LOG,
        endpointKey: EndpointKey.Signup,
        dispatch,
        metricsCounterDimensions
      });
    } else if (getIsMissingRecaptchaInformation(message)) {
      return handleRecaptchaMissingInformation({
        message,
        dispatch,
        endpointKey: EndpointKey.Signup
      });
    } else if (message) {
      dispatch(Tracker.creationError('creation-error-standard', `${statusCode} - ${message}`));
    } else {
      dispatch(Tracker.creationError('creation-error-standard', 'error-unknown'));
    }
  }
  return dispatch(setError(ErrorKey.StandardCreationError, {
    message
  }));
};